module.exports = __webpack_public_path__ + "static/media/hollow_bar_SMAP.239e07a0.svg";